import {
  FormControl,
  MenuItem,
  Select,
  Modal,
  DialogContent,
  Dialog,
} from "@material-ui/core";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import cogoToast from "cogo-toast";
import CustomButton from "../../../../components/CustomButton";
import CustomInput from "../../../../components/CustomInput";
import CustomTextArea from "../../../../components/CustomTextArea";
import StripeLogo from "../../../../assets/icons/stripelogo.png";
import { addPayment } from "../../../../redux/actions/payment";
import { addStripePayment } from "../../../../redux/actions/stripePaymentAction";
import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { getCurrencyFromCountry } from "../../../../utils/constants";

const AddFunds = ({ handleChangeStripe, amountStripe }) => {
  const dispatch = useDispatch();
  const [openDialog, setOpenDialog] = useState(false);
  const [openStripe, setOpenStripe] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingJara, setLoadingJara] = useState(false);
  const [stripeOrPaystackOption, setStripeOrPaystackOption] = useState(false);
  const stripe = useStripe();
  const elements = useElements();

  const { userData } = useSelector((state) => state.auth);

  const [transfers, setTransfers] = useState({
    email: userData?.email,
    amount: 0,
    description: "",
  });

  const handleCloseModalStripe = () => setOpenStripe(false);
  const handleOpenModalStripe = () => setOpenStripe(true);
  const handleCloseModal = () => setOpenDialog(false);
  const handleOpen = () => setOpenDialog(true);

  const handleChanges = (e) => {
    const { name, value } = e.target;
    setTransfers((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      cogoToast.error("Stripe.js has not loaded yet.");
      return;
    }

    setLoading(true);

    try {
      const { error: submitError } = await elements?.submit();
      if (submitError) {
        cogoToast.error(submitError.message);
        return;
      }

      // Convert amount to cents for Stripe
      const amountInCents = Math.round(Number(amountStripe) * 100);
      const userCurrency =
        getCurrencyFromCountry(userData?.country)?.toLowerCase() || "usd";
      const payload = {
        user_id: Number(userData?.id),
        amount: amountInCents, // Send amount in cents
        currency: userCurrency,
      };

      const action = await addStripePayment(dispatch, payload);
      const clientSecret = action.payload;

      const { error } = await stripe?.confirmPayment({
        elements,
        clientSecret,
        confirmParams: {
          return_url: `${window.location.origin}/payment-success`,
        },
      });

      if (error) {
        cogoToast.error(`Payment failed: ${error.message}`);
      } else {
        cogoToast.success("Payment successful!");
      }
    } catch (error) {
      cogoToast.error(`Unexpected error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleTransfer = async (e) => {
    e.preventDefault();
    if (!transfers.amount || !transfers.description) {
      cogoToast.error("All fields are required");
      return;
    }
    if (transfers.amount < 1000) {
      cogoToast.error("Amount must be greater than or equal to 1000");
      return;
    }

    setLoadingJara(true);

    const payload = {
      email: userData?.email,
      amount: Number(transfers.amount),
      description: transfers.description,
    };

    try {
      const action = await addPayment(dispatch, payload);
      if (action?.payload?.valid) {
        cogoToast.success(action.payload.message);
        const checkoutLink = action.payload.entity?.checkoutLink;
        if (checkoutLink) {
          window.open(checkoutLink, "_blank");
        } else {
          cogoToast.error("Checkout link is not available");
        }
      }
    } catch (error) {
      cogoToast.error("Error processing payment: " + error.message);
    } finally {
      setLoadingJara(false);
    }
  };

  return (
    <div className="m-5 pb-5">
      <h3 className="p-2" style={{ textAlign: "center" }}>
        Payment Options
      </h3>

      {/* Payment options container */}
      <div className="payment-options-container">
        {/* Show Stripe for non-Nigerian users */}
        {userData?.country !== "160" && (
          <div>
            {!stripeOrPaystackOption ? (
              // <button className="btn btn-lg btn-success px-5 py-2 rounded-3 shadow-lg hover:shadow-xl transition-all duration-200" onClick={handleOpenModalStripe}>
              //   <img src={StripeLogo} width="60" alt="Stripe" />
              // </button>

              <CustomButton
                backgroundColor="#3A6ED4"
                color="#fff"
                text="Stripe"
                additionalClass="mt-5 mb-2 btn-secondary"
                handleClick={handleOpenModalStripe}
              />
            ) : (
              <p></p>
            )}
          </div>
        )}

        {/* Show Jara Pay for Nigerian users */}
        {userData?.country === "160" && (
          <div>
            {/* <button
              style={{ padding: "10px", borderRadius: "10px" }}
              className="paystackBtn"
              onClick={handleOpen}
            >
              <b>Jara Pay</b>
            </button> */}
            <CustomButton
              backgroundColor="#3A6ED4"
              color="#fff"
              text="Jara Pay"
              additionalClass="mt-5 mb-2 btn-secondary"
              handleClick={handleOpen}
            />
          </div>
        )}
      </div>

      {/* Jara Pay Dialog */}
      <Dialog
        open={openDialog}
        onClose={handleCloseModal}
        aria-labelledby="form-dialog-title"
        PaperProps={{
          style: {
            width: "35rem",
            borderRadius: "1rem",
            padding: "0.75rem",
          },
        }}
      >
        <DialogContent>
          <h5>Add your Details</h5>
          <form className="pb-5" onSubmit={handleTransfer}>
            <CustomInput
              type="text"
              label="Amount"
              id="amount"
              name="amount"
              value={transfers.amount}
              onChange={handleChanges}
              placeholder="Enter amount in NGN"
            />

            <CustomTextArea
              id="description"
              name="description"
              type="text"
              label="Description"
              value={transfers.description}
              onChange={handleChanges}
              placeholder="Enter description"
            />

            <CustomButton
              backgroundColor="#3A6ED4"
              color="#fff"
              type="submit"
              text="Submit"
              additionalClass="mt-5 mb-2"
              loading={loadingJara}
            />
          </form>
        </DialogContent>
      </Dialog>

      {/* Stripe Dialog */}
      <Dialog
        open={openStripe}
        onClose={handleCloseModalStripe}
        aria-labelledby="form-dialog-title"
        PaperProps={{
          style: {
            width: "35rem",
            borderRadius: "1rem",
            padding: "0.75rem",
          },
        }}
      >
        <DialogContent
          style={{
            padding: "1rem",
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            overflow: "auto",
            maxHeight: "80vh",
          }}
        >
          <form
            onSubmit={handleSubmit}
            className="CheckoutForm flex flex-col gap-4"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "stretch",
            }}
          >
            <CustomInput
              type="text"
              label="Amount"
              id="amount"
              name="amount"
              placeholder="Enter amount in USD"
              value={amountStripe}
              onChange={handleChangeStripe}
            />

            <div
              className="payment-container"
              style={{ width: "100%", marginBottom: "1rem" }}
            >
              <PaymentElement />
            </div>

            <CustomButton
              backgroundColor="#3A6ED4"
              color="#fff"
              type="submit"
              text="Pay Now"
              additionalClass="mt-5"
              loading={loading}
            />
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AddFunds;
